import React, { CSSProperties, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
interface FieldsetProps {
    title?: ReactNode;
    color?: string;
    titleSize?: string;
    borderColor?: CSSProperties['borderColor'];
    borderWidth?: number;
    borderRadius?: number;
    children: ReactNode;
    sx?: SxProps<Theme>;
}
const Fieldset = ({ title, color = 'primary', titleSize = '1rem', borderColor = 'divider', borderWidth = 1, borderRadius = 1, children, sx = {}, ...props }: FieldsetProps) => {
    return (
        <Box
            component='fieldset'
            sx={{
                borderColor: borderColor,
                borderWidth: borderWidth,
                borderRadius: borderRadius,
                p: 1,
                m: 0,
                ...sx,
            }}
            {...props}
        >
            {title && (
                <Typography
                    component='legend'
                    sx={{
                        px: 0.5,
                        color: color,
                        fontSize: titleSize,
                    }}
                >
                    {title}
                </Typography>
            )}
            {children}
        </Box>
    );
};
export default Fieldset;
